import * as TaskRunner from 'util/TaskRunner';

export interface SendDeepResearchMessageResponse {}

export function sendDeepResearchMessage(
  chatId: string | undefined,
  message: string
): Promise<SendDeepResearchMessageResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/llm/deep-research',
    data: {chatId, message},
  });
}
